// extracted by mini-css-extract-plugin
module.exports = {"feed":"FeedPhotos_feed__SCL9f"};